
export const LIFECYCLE_LERNIE_CHAT_WILL_START = 'timewreck/lifecycle/LERNIE_CHAT_WILL_START';
export const LIFECYCLE_LERNIE_ALTERNATIVE_CHAT = 'timewreck/lifecycle/LERNIE_ALTERNATIVE_CHAT';
export const LIFECYCLE_GAME_WILL_START = 'timewreck/lifecycle/GAME_WILL_START';
export const LIFECYCLE_LERNIE_ENDED_SPEAKING = 'timewreck/lifecycle/LERNIE_ENDED_SPEAKING';
export const LIFECYCLE_LERNIE_ENDED_DEBRIEF = 'timewreck/lifecycle/LERNIE_ENDED_DEBRIEF';
